import React from 'react';

/**
 * Aviso exibido na area do grafico quando a estimativa de complexidade da
 * consulta tem veredito 'vermelho' (limite tecnico). Impede que o usuario
 * fique vendo um grafico stale (de uma consulta anterior) enquanto o painel
 * de controle ja sinaliza que a selecao atual e inviavel.
 *
 * Texto alinhado ao bloco vermelho do `MedidorComplexidade`, sem repetir o
 * detalhamento por fator (que ja aparece no painel).
 */
export default function AvisoConsultaInviavel() {
  return (
    <div className="mt-4 p-4 border rounded text-muted text-center">
      <strong>Consulta inviável (limite técnico).</strong>
      {' '}
      Reduza a seleção ou agregue para visualizar o gráfico.
    </div>
  );
}
